import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import { genericError } from '@/utils/alerts.service';

export const actions = {
  async fetchCategories({ dispatch, commit }) {
    return vendorDashboardAPI
      .getCategories()
      .then(data => {
        commit('setCategories', data.results);
      })
      .catch(() => {
        dispatch('showUserMessage', { ...genericError }, { root: true });
      });
  },

  async fetchCollections({ dispatch, commit }) {
    return vendorDashboardAPI
      .getCollections()
      .then(data => {
        commit('setCollections', data.results);
      })
      .catch(() => {
        dispatch('showUserMessage', { ...genericError }, { root: true });
      });
  },

  async fetchFilters({ dispatch, commit }) {
    return vendorDashboardAPI
      .getFilters()
      .then(data => {
        commit('setFilters', data.results);
      })
      .catch(() => {
        dispatch('showUserMessage', { ...genericError }, { root: true });
      });
  },

  async fetchTiers({ dispatch, commit }) {
    return vendorDashboardAPI
      .getTiers()
      .then(data => {
        commit('setTiers', data.results);
      })
      .catch(() => {
        dispatch('showUserMessage', { ...genericError }, { root: true });
      });
  },

  async fetchBadges({ dispatch, commit }) {
    return vendorDashboardAPI
      .getBadges()
      .then(data => {
        commit('setBadges', data.results);
      })
      .catch(() => {
        dispatch('showUserMessage', { ...genericError }, { root: true });
      });
  },

  async fetchDetails({ dispatch, commit }) {
    return vendorDashboardAPI
      .getDetails()
      .then(data => {
        commit('setDetails', data);
        sessionStorage.setItem('vendorName', data.vendorData.name);
      })
      .catch(() => {
        dispatch('showUserMessage', { ...genericError }, { root: true });
      });
  },
};
